import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// Component
import Footer from "./Component/Footer";
// Redux
import { LoadUser } from "../Auth/redux/Auth";
import { GetNotification } from "../Redux/Notification";

const Index = () => {
  const { isLoggedIn, user, isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    if ((isLoggedIn === true && user === undefined) || (isLoggedIn === false && isAuthenticated === undefined) || (isLoggedIn === -1 && isAuthenticated === -1)) {
      dispatch(LoadUser());
      dispatch(GetNotification(0));
    }
  }, [isLoggedIn, user, isAuthenticated, dispatch]);

  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if the user agent contains 'iPhone' or 'iPad' to identify iOS devices
    setIsIOS(/iPhone|iPad|iPod/i.test(navigator.userAgent));
  }, []);

  return (
    <div className={`CustomerIndex ${isIOS ? `isIOS` : `isNotIOS`}`}>
      <Outlet />
      <Footer />
    </div>
  );
};

export default Index;
